import { useAuthStore } from '@/store/auth';

export function can(permission: string): boolean {
  const authStore = useAuthStore();
  // Check if the user has the given permission
  return authStore.permissions.includes(permission);
}

export function hasRole(role: string): boolean {
  const authStore = useAuthStore();
  // Check if the user has the given role
  return authStore.roles.includes(role);
}

export function checkAccess(permission: string, role?: string): boolean {
  const authStore = useAuthStore();
  // First check if the user has the permission
  if (authStore.permissions.includes(permission)) return true;

  // If a role is provided, check if the user has the role
  if (role && authStore.roles.includes(role)) return true;

  return false;
}
